module.exports = __webpack_public_path__ + "img/map-placeholder-north-small.40295d24.png";